export default __webpack_public_path__ + "static/media/box.6c323e52.svg";